import { PageSize } from '../Pagination';
import { FilterInput } from './FilterInput';
import { idBuilder } from '../internal';
import { Box } from '../Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const styledFilterDiv = {
  display: 'flex',
  position: 'relative',
  minHeight: '40px',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};
export const styledFilterContainer = {
  width: '100%',
  display: 'inline-flex',
  justifyContent: 'start',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};
export const styledPaginationPageSizeContainer = {
  display: 'inline-flex',
  justifyContent: 'end',
  position: 'absolute',
  bottom: 0,
  right: 0,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};
export const StyledFilter = _ref => {
  let {
    setFilterData,
    id,
    dataDensity,
    placeholder,
    displayFilter,
    pageSize,
    displayPageSizeSelector,
    defaultPageSize,
    onShowSizeChange,
    paginationPageSizeOptions,
    ...rest
  } = _ref;
  if (displayFilter || displayPageSizeSelector) {
    return /*#__PURE__*/_jsxs(Box, {
      sx: styledFilterDiv,
      children: [/*#__PURE__*/_jsx(Box, {
        sx: styledFilterContainer,
        children: displayFilter && /*#__PURE__*/_jsx(FilterInput, {
          setFilterData: setFilterData,
          id: idBuilder('ids-table-filter', id),
          "data-testid": idBuilder('ids-table-filter', rest['data-testid']),
          dataDensity: dataDensity,
          placeholder: placeholder
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: styledPaginationPageSizeContainer,
        className: 'ids-table-page-size-selector-top',
        children: displayPageSizeSelector && /*#__PURE__*/_jsx(PageSize, {
          onShowSizeChange: onShowSizeChange,
          pageSize: pageSize,
          defaultPageSize: defaultPageSize,
          pageSizeOptions: paginationPageSizeOptions,
          size: "medium",
          id: idBuilder('table', id),
          "data-testid": idBuilder('table', rest['data-testid'])
        })
      })]
    });
  }
  return null;
};